import script from "./OperationalNotesKb.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationalNotesKb.vue?vue&type=script&setup=true&lang=js"

import "./OperationalNotesKb.vue?vue&type=style&index=0&id=6519c5e9&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6519c5e9"]])

export default __exports__